export const BG_PRIMARY = '#F0E9DA';
export const BG_SECONDARY = '#60879F';
export const BG_SECONDARY_LIGHT = '#dca74f';
export const BG_SECONDARY_DARK = '#86550a';
export const BG_SECONDARY_TRANSPARENT = 'rgb(7 58 40 / 29%)';
// this colors used for green background
export const BG_ALTERNATIVE = '#60879F';
export const TEXT_PRIMARY_LIGHT = '#60879F';
export const TEXT_PRIMARY = '#E3A74B';
export const TEXT_PRIMARY_DARK = '#000';
export const TEXT_SECONDARY = '#fff';
